/**
 * Fix Sessions API — provenance spellcheck review relay.
 */

import { apiClient } from "./client";

// -- Types --

export interface FixDiagnostic {
  diagnostic_type: string;
  file: string;
  line: number;
  code: string;
  var_name: string | null;
  inner_expr: string | null;
  suggestion_a: string | null;
  suggestion_b: string | null;
  input_type: string | null;
  timestamp: string;
}

export interface FixContextWindow {
  before_lines: [number, string][];
  after_lines: [number, string][];
  target_idx: number;
  stale: boolean;
  stale_reason: string;
}

export interface FixDecision {
  index: number;
  action: "accept" | "skip";
}

export interface FixSession {
  id: string;
  project_id: string;
  status: "pending" | "in_progress" | "complete";
  diagnostics: FixDiagnostic[];
  contexts: FixContextWindow[];
  decisions: FixDecision[];
  created_at: string;
  completed_at: string | null;
}

// -- API Functions --

export function fetchFixSession(sessionId: string): Promise<FixSession> {
  return apiClient<FixSession>(`/fix/sessions/${sessionId}`);
}

export function updateFixDecisions(
  sessionId: string,
  decisions: FixDecision[],
  status: "in_progress" | "complete",
): Promise<FixSession> {
  return apiClient<FixSession>(`/fix/sessions/${sessionId}`, {
    method: "PATCH",
    body: { decisions, status },
  });
}
